/**
 * Abbreviations
 *
 * c_psd -> cached partial startup data
 *       -> 0: not cached | 1: valid cache
 * c_em  -> cached emails
 *       -> 0: not cached | 1: valid cache
 */
type DiagnosticsKeys = 'c_psd' | 'c_em';
/* eslint-disable-next-line @typescript-eslint/no-explicit-any --
 * See aka.ms/mini-lint-errors
 *	> Unexpected any. Specify a different type. */
type BootstrapPerformanceDiagnostics = Record<DiagnosticsKeys, any>;

const bootstrapPerformanceDiagnostics: Partial<BootstrapPerformanceDiagnostics> = {};

/* eslint-disable-next-line @typescript-eslint/no-explicit-any --
 * See aka.ms/mini-lint-errors
 *	> Unexpected any. Specify a different type. */
export const addBootstrapPerformanceDiagnostics = (key: DiagnosticsKeys, value: any) => {
    bootstrapPerformanceDiagnostics[key] = value;
};

export const getBootstrapPerformanceDiagnostics = () => bootstrapPerformanceDiagnostics;
